<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- rtu选择 -->
        <div class="label">分组名称：</div>
        <Select v-model="search.rtuCode" @on-change="handleManualTypeChange" style="width: 7.8em" placeholder="请选择分组"
          clearable>
          <Option v-for="item in rtuList" :value="item.code" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <div class="label">小时范围：</div>
        <Select v-model="dateTimes.startHour" clearable style="width: 100px; margin-left: 10px; text-align: center">
          <Option v-for="item in hourList" :key="item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
        -
        <Select v-model="dateTimes.endHour" clearable style="width: 100px; margin-left: 10px; text-align: center">
          <Option v-for="item in hourList" :key="item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;
}
</style>

<style>
.ivu-table-border td,
.ivu-table-border th {
  border-right: 1px solid #dadada !important;
}

.ivu-table td,
.ivu-table th {
  border-bottom: 1px solid #dadada !important;
}

.ivu-table td,
.ivu-table th {
  height: 42px !important;
}
</style>

<script>
import toolbar from "../toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
      // 查询
      search: {
        rtuCode: null,
        startDate: new Date(new Date()).setHours("0"),
        endDate: new Date(new Date()).setHours("24"),
        startHour: 0,
        endHour: 23,
      },
      dateTimes: {
        startDate: null,
        endDate: null,
        startHour: null,
        endHour: null,
      },
      rtuList: [], // rtu枚举列表
      hourList: [], //小时范围
    };
  },
  components: {
    toolbar,
  },
  created() {
    this.getRtuEnum(); // 获取rtu端口对应设备 渲染表头 数据初始化
    this.tableInit(); // 表格初始化
    window.addEventListener("resize", this.tableInit);
    for (let i = 0; i < 24; i++) {
      let hour = {};
      hour["value"] = i;
      hour["name"] = i + "点";
      this.hourList.push(hour);
    }
  },
  methods: {
    handleManualTypeChange() {
      this.getRtuDevice();
    },
    getData() {
      // 初始化小时
      if (this.dateTimes.startHour != null) {
        this.search.startHour = this.dateTimes.startHour;
      }
      if (this.dateTimes.endHour != null) {
        this.search.endHour = this.dateTimes.endHour;
      }
      if (this.dateTimes.startDate != null) {
        this.search.startDate = new Date(this.dateTimes.startDate).setHours("0");
      }
      if (this.dateTimes.endDate != null) {
        this.search.endDate = new Date(this.dateTimes.endDate).setHours("24");
      }

      // 获取数据
      this.table.loading = true;
      this.$api.Report.getReportList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search,
        },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let data = res.data.list;
          // data.map((prop, index) => {
          //   for (let i = 0; i < 8; i++) {
          //     if (!prop["ai" + i + "Normal"]) {
          //       if (!data[index].cellClassName) {
          //         data[index].cellClassName = {};
          //       } else {
          //         data[index].cellClassName["ai" + i] =
          //           "demo-table-info-cell-warning";
          //       }
          //     }
          //   }
          // });
          this.table.data = data;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getRtuDevice();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取rtu枚举值
    getRtuEnum() {
      this.$api.Enum.getRtuEnum(null, ["uuid", "company"]).then((res) => {
        if (res.code == 0) {
          this.rtuList = res.data;
          if (this.rtuList.length == 0) {
            // 当没有rtu的情况下
            this.getData();
            return;
          }
          // 获取枚举数据后 默认选择第一个枚举查rtu端口对应设备
          if (this.rtuList.length != 0) {
            this.search.code = this.rtuList[0].code;
            this.search.rtuCode = this.rtuList[0].code;
            this.getRtuDevice();
          }
        } else {
          this.$Notice.warning({
            title: "获取分组枚举失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
    // 获取rtu 8个端口对应的设备
    getRtuDevice() {
      this.$api.Deploy.getRtuList({ content: { code: this.search.rtuCode } }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0 && res.data.list.length != 0) {
          let data = res.data.list[0];
          let columns = [];
          columns.push({
            title: "日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          });

          for (let i = 0; i < 9; i++) {
            if (data["aI" + i] > 0) {
              let temp = {};
              if (data["aI" + i + "DeviceName"]) {
                temp.title = data["aI" + i + "DeviceName"] + "(" + data["aI" + i + "Unit"] + ")";
                temp.align = "center";
                temp.key = `ai${i}`;
              }
              columns.push(temp);
            }
          }
          this.table.columns = columns;
          this.getData(); // 渲染好表头后加载数据
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.dateTimes.startDate = date[0];
      this.dateTimes.endDate = date[1];
      //console.log(this.search);
    },
    // 表格高度计算
    tableInit() {
      let headerH = emComputed(14.5); // header高度7em加操作栏5.5em转换px， 2em的上下边距分页组件
      this.table.maxHeight = window.innerHeight - headerH - 32; // 32px的分页组件高度
      if (this.$route.path != "/chome/reportTable") {
        window.removeEventListener("resize", this.tableInit);
      }
    },
  },
};
</script>